//BRAND oneill
import logo from 'assets/images/brand/logo.png';
import fullLogo from 'assets/images/brand/fullLogo.svg';
import fullLogoGrayScale from 'assets/images/brand/fullLogoGrayScale.svg';

//BRAND sunshine
import sunshineLogo from 'assets/images/brand_sunshine/SLH-Madrinas_Logos.svg';
import sunshineLogoWhite from 'assets/images/brand_sunshine/SLH-Madrinas_Logos_White.svg';

//SVG
import agentInfo from 'assets/images/svg/agentInfo.svg';

// Get company variable
import { getCompany } from 'helpers/getCompanyVariables';

const company = getCompany();

const isOneill = company === 'oneill';

let images = {};
if (isOneill) {
  images = {
    brand: {
      logo: logo,
      fullLogo: fullLogo,
      fullLogoGrayScale: fullLogoGrayScale,
      placeHolder:
        'https://firebasestorage.googleapis.com/v0/b/o-neill-marketing-portal.appspot.com/o/Employee%20Profile%20Pics%2Fuser-thumbnail(20).png?alt=media&token=a857dcc3-79f8-4783-9a95-ccfd9fcdd709'
    },
    svg: {
      agentInfo: agentInfo
    },
    agentSuccess: {
      teamPhoto:
        'https://oneill-static-assets.s3.us-east-1.amazonaws.com/agent-success-team.webp'
    }
  };
}
if (company === 'sunshine') {
  images = {
    brand: {
      logo: sunshineLogo,
      fullLogo: sunshineLogo,
      fullLogoGrayScale: sunshineLogo,
      // the lockup's wordmark is navy ink, so dark panels need the white artwork.
      // oneill has no equivalent: its bundled marks read on either background
      logoOnDark: sunshineLogoWhite,
      placeHolder:
        'https://firebasestorage.googleapis.com/v0/b/o-neill-marketing-portal.appspot.com/o/Employee%20Profile%20Pics%2Fuser-thumbnail(20).png?alt=media&token=a857dcc3-79f8-4783-9a95-ccfd9fcdd709'
    },
    svg: {
      agentInfo: agentInfo
    }
  };
}

export default images;
